import { z } from 'zod';
export const TemplatesParameterSchema = z.enum(['TEMPLATES_BASE_URL']);
export const TemplatesParameterEnum = TemplatesParameterSchema.enum;
